import React from "react";

import {
    Input,
    message,
    Modal,
    Select,
} from "antd";

import nations from "../../modules/nations";
import { COUNTRY_CODE } from "../../index";

import { 
    _postEnterpriseOciPunchoutCredentials,
} from "../../services";

class EnterpriseOciPunchoutCredentialsModal extends React.Component{

    constructor(props){
        super(props);

        this.state = {

            /* boolean flag */
            confirmLoading: false,

            /* oci punchout form data */
            ociPunchoutUsername: "",
            ociPunchoutPassword: "",
            ociPunchoutProductIdField: "",
			email: "",
			departmentCode: "",
            isoCountryCode: COUNTRY_CODE,

            /* enterprise data */
            enterpriseDomainNames: this.props.enterprise.domainNames,
			enterpriseId: this.props.enterprise._id, 
        }

    }

    shouldComponentUpdate(){
        return false;
    }

    render(){
        return (
            <Modal 
                confirmLoading={this.state.confirmLoading}
                title="Add Oci Punchout Credentials?"
                onCancel={ this.props.onCancel }
                visible={ this.props.visible }
                onOk={ this.onClickConfirm }
                okText="Confirm">

                <h3>Username</h3>
                <Input 
                    name="ociPunchoutUsername" 
                    onChange={ this.onChangePunchoutField } />

                <h3>Password</h3>
                <Input 
                    name="ociPunchoutPassword" 
                    onChange={ this.onChangePunchoutField } />

                <h3>Product Id Field</h3>
                <Input 
                    name="ociPunchoutProductIdField" 
                    onChange={ this.onChangePunchoutField } />

                <h3>Email</h3>
                <Input 
                    name="email" 
                    onChange={ this.onChangePunchoutField } />

                <h3>Department Code</h3>
                <Input 
                    name="departmentCode" 
                    onChange={ this.onChangePunchoutField } />
                
                <h3>Iso Country Code</h3>
                <Select style={{ width: 200 }} defaultValue={COUNTRY_CODE} onChange={ this.onSelectIsoCountry }>
                    {nations.map( nation => (
                        <Select.Option value={nation.code}>
                            {nation.name}
                        </Select.Option>
                    ))}
                </Select>

            </Modal>
        );
    }

    getCleanData = () => {

        let { 
            ociPunchoutUsername,
            ociPunchoutPassword,
            ociPunchoutProductIdField,
			email,
			departmentCode,
            isoCountryCode
        } = this.state;

        ociPunchoutUsername = ociPunchoutUsername.trim().toLowerCase();
        ociPunchoutPassword = ociPunchoutPassword.trim();
        ociPunchoutProductIdField = ociPunchoutProductIdField.trim();
        email = email.trim().toLowerCase();
        departmentCode = departmentCode.trim();
        isoCountryCode = isoCountryCode.trim();

        return {
            ociPunchoutUsername,
            ociPunchoutPassword,
            ociPunchoutProductIdField,

            email,
            departmentCode,
            isoCountryCode
        };
    }

    onChangePunchoutField = ( e ) => {

        this.setState({
            [e.target.name]: e.target.value
        });

    }

    onClickConfirm = async () => {
        
        /* check for errors */
        let { 
            ociPunchoutUsername,
            ociPunchoutPassword,
            ociPunchoutProductIdField,
			email,
			departmentCode,
            isoCountryCode,
        } = this.getCleanData();
        
        let { enterpriseDomainNames, enterpriseId } = this.state;

        /* check if all required fields are filled up */
        if( !this.passRequiredFieldsCheck() ){
            return message.error("All fields are required!");
        }

        /* check if email matches enterprise domain */
        if( !this.passEnterpriseApprovedDomainNameCheck( enterpriseDomainNames, email ) ){

            let domainNameString = "";
            enterpriseDomainNames.map( domainName => {
                domainNameString += `, ${domainName}`;
            });
            return message.error(`Email does not match enterprise's approved domain name${domainNameString}`);

        }

        /* check if email matches regex */
        if( !this.passEmailRegexCheck( email ) ){
            return message.error("Invalid email!");
        }

        this.setState({ confirmLoading: true });

        try{

            let res = await _postEnterpriseOciPunchoutCredentials({
                ociPunchoutUsername,
                ociPunchoutPassword,
                ociPunchoutProductIdField,
                email,
        
                enterpriseId, 
                departmentCode,
                isoCountryCode        
            });

            message.success("Oci Punchout Credentials added successfully!");

            this.setState({ confirmLoading: false });

            this.props.onAddNewCredentials( res.data.ociPunchoutCredential );
            
        } catch ( e ){

            this.setState({ confirmLoading: false });

            if( e && e.response && e.response.data.statusmsg ){
                message.error( e.response.data.statusmsg );
            } else {
                message.error( e.toString() );
            }

        }

    }

    onSelectIsoCountry = ( isoCountryCode ) => {

        console.log( this.state );

        this.setState({
            isoCountryCode
        });

    }

    passEmailRegexCheck = ( email ) => {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    passEnterpriseApprovedDomainNameCheck = ( enterpriseDomainNames, email ) => {
        let passedEmailCheck = false;
        for (let i = 0; i < enterpriseDomainNames.length; i++) {
            const domainName = enterpriseDomainNames[i];
            if( email.endsWith(domainName) ){
                passedEmailCheck = true;
            }
        }

        return passedEmailCheck;
    }

    passRequiredFieldsCheck = () => {
        let { 
            ociPunchoutUsername,
            ociPunchoutPassword,
            ociPunchoutProductIdField,
			email,
			departmentCode,
            isoCountryCode,
        } = this.getCleanData();

        if( 
            !ociPunchoutUsername || 
            !ociPunchoutPassword ||  
            !ociPunchoutProductIdField ||
            !email ||  
            !departmentCode ||  
            !isoCountryCode
        ){
            return false;
        }

        return true;
    }

}

export default EnterpriseOciPunchoutCredentialsModal;



// WEBPACK FOOTER //
// ./src/components/enterprise/enterprise-oci-punchout-credentials-modal.js